var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.5H6.5C5.39 2.5 4.5 3.39 4.5 4.5V20.5C4.5 21.61 5.39 22.5 6.5 22.5H14.31C13.78 21.59 13.5 20.55 13.5 19.5C13.5 19.17 13.53 18.83 13.58 18.5H6.5V16.5H14.31C14.77 15.7 15.41 15 16.18 14.5H6.5V12.5H18.5V13.58C18.83 13.53 19.17 13.5 19.5 13.5C19.83 13.5 20.17 13.53 20.5 13.58V8.5L14.5 2.5ZM13.5 9.5V4L19 9.5H13.5ZM18.5 15.5V18.5H15.5V20.5H18.5V23.5H20.5V20.5H23.5V18.5H20.5V15.5H18.5Z",
    fill: "#002C3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignTask);
export default __webpack_public_path__ + "static/media/Assign Task.a7820496c2968df8cc45e093f99d3072.svg";
export { ForwardRef as ReactComponent };